const TOKEN = "access_token"
const USER = "access_user"
const OUTLET = "access_outlet"
const MENU = "access_menu"
const FCM = "access_fcm"
const RELOAD = "access_reload"
const COMPANY = "access_company"
const COLOR = "access_color"
const COUNTER = "access_counter"

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/
const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN)
  },
  getUser() {
    return localStorage.getItem(USER)
  },
  getOutlet() {
    return localStorage.getItem(OUTLET)
  },
  getMenu() {
    return localStorage.getItem(MENU)
  },
  getFcm() {
    return localStorage.getItem(FCM)
  },
  getReload() {
    return localStorage.getItem(RELOAD)
  },
  getCompany() {
    return localStorage.getItem(COMPANY)
  },
  getColor() {
    return localStorage.getItem(COLOR)
  },
  getCounter() {
    return localStorage.getItem(COUNTER)
  },

  saveToken(accessToken, accessUser, accessMenu) {
    localStorage.setItem(TOKEN, accessToken)
    localStorage.setItem(USER, accessUser)
    localStorage.setItem(MENU, accessMenu)
  },
  saveOutlet(accessOutlet) {
    localStorage.setItem(OUTLET, accessOutlet)
  },
  updateMenu(accessMenu) {
    localStorage.setItem(MENU, accessMenu)
  },
  saveFcm(accessFcm) {
    localStorage.setItem(FCM, accessFcm)
  },
  saveReload(accessReload) {
    localStorage.setItem(RELOAD, accessReload)
  },
  saveCompany(accessCompany) {
    localStorage.setItem(COMPANY, accessCompany)
  },
  saveColor(accessColor) {
    localStorage.setItem(COLOR, accessColor)
  },
  saveCounter(accessCounter) {
    localStorage.setItem(COUNTER, accessCounter)
  },
  
  removeToken() {
    localStorage.removeItem(TOKEN)
    localStorage.removeItem(USER)
    localStorage.removeItem(MENU)
    localStorage.removeItem(FCM)
    localStorage.removeItem(RELOAD)
    localStorage.removeItem(COMPANY)
    localStorage.removeItem(COLOR)
    localStorage.removeItem(COUNTER)
  }
}

export { TokenService }